import { Loader } from '@progress/kendo-react-indicators';

const Loading = (): React.ReactElement => (
  <div className="load" data-testid="loading">
    <Loader type="converging-spinner" size="large" themeColor="primary" />
  </div>
);

export default Loading;
